/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthDocumentSource = {
    NetHealth: 'net_health',
    PointClickCare: 'point_click_care',
    UserUpload: 'user_upload',
} as const;
export type PalReauthDocumentSource = typeof PalReauthDocumentSource[keyof typeof PalReauthDocumentSource];


export function instanceOfPalReauthDocumentSource(value: any): boolean {
    for (const key in PalReauthDocumentSource) {
        if (Object.prototype.hasOwnProperty.call(PalReauthDocumentSource, key)) {
            if (PalReauthDocumentSource[key as keyof typeof PalReauthDocumentSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthDocumentSourceFromJSON(json: any): PalReauthDocumentSource {
    return PalReauthDocumentSourceFromJSONTyped(json, false);
}

export function PalReauthDocumentSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthDocumentSource {
    return json as PalReauthDocumentSource;
}

export function PalReauthDocumentSourceToJSON(value?: PalReauthDocumentSource | null): any {
    return value as any;
}

export function PalReauthDocumentSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthDocumentSource {
    return value as PalReauthDocumentSource;
}

